import { ConditionSelector, OperatorSelector, ValueEditor } from '../components';
import { useConditionBuilderStore } from '../store';

export const useConditionFields = () => {
  const ValueEditorComponent = useConditionBuilderStore((state) =>
    state.controlElements?.valueEditor === undefined
      ? ValueEditor
      : state.controlElements?.valueEditor
  );

  const ConditionSelectorComponent = useConditionBuilderStore((state) =>
    state.controlElements?.conditionSelector === undefined
      ? ConditionSelector
      : state.controlElements.conditionSelector
  );

  const OperatorSelectorComponent = useConditionBuilderStore((state) =>
    state.controlElements?.operatorSelector === undefined
      ? OperatorSelector
      : state.controlElements.operatorSelector
  );

  return {
    ValueEditorComponent,
    ConditionSelectorComponent,
    OperatorSelectorComponent,
  };
};
